import script from "./RubricaVisorModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./RubricaVisorModal.vue?vue&type=script&lang=ts&setup=true"

import "./RubricaVisorModal.vue?vue&type=style&index=0&id=0348b8b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0348b8b1"]])

export default __exports__